import { useState } from "react";

const useQuizState = () => {
    const [quizLoader, setQuizLoader] = useState(false);
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [quizCertificate, setQuizCertificate] = useState(null);
    const [quizResults, setQuizResults] = useState({});
    const [quizSubmitted, setQuizSubmitted] = useState(false);
    const [answeredQuestions, setAnsweredQuestions] = useState([]);
    const [performanceByModule, setPerformanceByModule] = useState([]);
    const [performance_data, setPerformanceData] = useState({});

    return {
        quizLoader,
        setQuizLoader,
        currentQuestion,
        setCurrentQuestion,
        quizCertificate,
        setQuizCertificate,
        quizResults,
        setQuizResults,
        quizSubmitted,
        setQuizSubmitted,
        answeredQuestions,
        setAnsweredQuestions,
        performanceByModule,
        setPerformanceByModule,
        performance_data,
        setPerformanceData,
    };
};

export default useQuizState;
